var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.show)?_c('div',{staticClass:"float"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/query/#/form"}},[_c('img',{attrs:{"src":require("./assets/message2.png"),"alt":""}})])
}]

export { render, staticRenderFns }